import CompanyInformationsService from './CompanyInformations.service'
export default CompanyInformationsService
